import { ApplicationConfig, provideZoneChangeDetection } from "@angular/core";
import { provideAnimationsAsync } from "@angular/platform-browser/animations/async";
import { provideAnimations } from "@angular/platform-browser/animations";
import { provideHttpClient, withInterceptors } from "@angular/common/http";
import { provideRouter } from "@angular/router";
import { provideStore } from "@ngrx/store";
import { providePrimeNG } from "primeng/config";
import { environment } from "../environments/environment";
import { authInterceptor } from "./common/interceptors/auth.interceptor";
import { httpInterceptor } from "./common/interceptors/http.interceptor";
import { appRoutes } from "./app.routes";
import { appReducers } from "./common/ngrx/root.reducer";
import { appPrimeNGConfig } from "./app.theme";

export const appConfig: ApplicationConfig = {
  providers: [
    provideAnimations(),
    provideAnimationsAsync(),
    provideHttpClient(withInterceptors([authInterceptor, httpInterceptor])),
    provideRouter(appRoutes),
    provideStore(appReducers),
    provideZoneChangeDetection({ eventCoalescing: true }),
    providePrimeNG(appPrimeNGConfig),
    environment.providers,
  ],
};
